import React from 'react';

import { formatFigure } from 'Helpers/formatService';

export default function ReportBudgetRisksOpportunitiesIndexTableRow(props) {
    return (
        <tr key={props.budgetRiskOpportunity.id}>
            <td>{props.budgetRiskOpportunity.is_risk ? $t('Risk') : $t('Opportunity')}</td>
            <td>{props.budgetRiskOpportunity.name}</td>
            <td className="tw-break-all">{props.budgetRiskOpportunity.description}</td>
            <td>{props.budgetRiskOpportunity.is_specific ? $t('Yes') : $t('No')}</td>
            <td className="tw-text-right">{formatFigure(props.budgetRiskOpportunity.amount)}</td>
            <td>{props.budgetRiskOpportunity.department_name}</td>
            <td>{props.budgetRiskOpportunity.riskable_name}</td>
        </tr>
    );
}
